import React, { useCallback, useEffect, useState } from 'react'
import "./OtaDashboard.css"
import SideBar from "../../components/SideBar/SideBar"
import WebHeader from "../../components/WebHeader/WebHeader"
import { Outlet, useLocation } from 'react-router-dom'
import UpdateSystemFullScreenModal from '../../components/UpdateSystemFullScreenModal/UpdateSystemFullScreenModal'
import { connect } from 'react-redux'
import { setSystemInactiveFullScreenModal, setSystemUpdateFullScreenModal, setUploadSystemVersionFullScreenModal } from '../../modules/actions/action'
import InactivateSystemVersionFullScreenModal from '../../components/InactivateSystemVersionFullScreenModal/InactivateSystemVersionFullScreenModal'
import UploadSystemVersionFullScreenModal from '../../components/UploadSystemVersionFullScreenModal/UploadSystemVersionFullScreenModal'
import { clearMachineDetailsSession } from '../../container/MachineDetails/machineDetailsSession'

const MOBILE_SIDEBAR_QUERY = '(max-width: 1024px)';
const MACHINE_DETAILS_PATH = '/ota-details/machine-details';

const OtaDashboard = (props) => {
	const location = useLocation();
	const [sidebarOpen, setSidebarOpen] = useState(false);

	const closeSidebar = useCallback(() => setSidebarOpen(false), []);
	const toggleSidebar = useCallback(() => setSidebarOpen((open) => !open), []);

	useEffect(() => {
		closeSidebar();
	}, [location.pathname, closeSidebar]);

	useEffect(() => {
		if (!location.pathname.includes(MACHINE_DETAILS_PATH)) {
			clearMachineDetailsSession();
		}
	}, [location.pathname]);

	useEffect(() => {
		const mediaQuery = window.matchMedia(MOBILE_SIDEBAR_QUERY);
		const handleViewportChange = (event) => {
			if (!event.matches) {
				closeSidebar();
			}
		};

		mediaQuery.addEventListener('change', handleViewportChange);
		return () => mediaQuery.removeEventListener('change', handleViewportChange);
	}, [closeSidebar]);

	useEffect(() => {
		document.body.classList.toggle('app-sidebar-open', sidebarOpen);
		return () => document.body.classList.remove('app-sidebar-open');
	}, [sidebarOpen]);

	return (
		<div className="ota-management-main-container">
			{props.showUpdateSystemModal && <div className='full-screen-system-update-modal'>
				<UpdateSystemFullScreenModal />
			</div>}
			{props.showInactiveSystemModal && <div className='full-screen-system-update-modal'>
				<InactivateSystemVersionFullScreenModal />
			</div>}

			{props.showUploadSystemModal && <div className='full-screen-system-update-modal'>
				<UploadSystemVersionFullScreenModal/>	
			</div>}

			<SideBar isOpen={sidebarOpen} onClose={closeSidebar} />
			<div className='ota-dashboard-screen'>
				{sidebarOpen && (
					<button
						type="button"
						className="app-sidebar-backdrop"
						aria-label="Close navigation menu"
						onClick={closeSidebar}
					/>
				)}
				<div className='ota-dashboard-main'>
					<WebHeader onMenuToggle={toggleSidebar} sidebarOpen={sidebarOpen} />
					<div className='ots-container'>
						<Outlet />
					</div>
				</div>
			</div>
		</div>
	)
};

const mapStateToProps = state => {
	return {
		showUpdateSystemModal: state.systemUpdateFullScreenModal.showSystemUpdateModal,
		showInactiveSystemModal: state.systemInactiveFullScreenModal.showSystemInactiveModal,
		showUploadSystemModal: state.uploadSystemVersionFullScreenModal.showUploadSystemVersionModal,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		openSystemUpdateModal: () => { dispatch(setSystemUpdateFullScreenModal(true)) },
		closeSystemUpdateModal: () => { dispatch(setSystemUpdateFullScreenModal(false)) },
		openSystemInactiveModal: () => { dispatch(setSystemInactiveFullScreenModal(true)) },
		closeSystemInactiveModal: () => { dispatch(setSystemInactiveFullScreenModal(false)) },
		openUploadSystemVersionModal: () => { dispatch(setUploadSystemVersionFullScreenModal(true)) },
        closeUploadSystemVersionModal: () => { dispatch(setUploadSystemVersionFullScreenModal(false)) },
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(OtaDashboard);
